import Tasks from 'features/Work/components/FormSectionsContent/TasksContent';

import General from './General';
import Options from './Options';
import Payment from './Payment';

const Sections = { General, Options, Payment, Tasks };

export default Sections;
